import { Component } from '@angular/core';

@Component({
  selector: 'public-views',
  templateUrl: './public-views.component.html'
})
export class PublicViewsComponent {

}



// WEBPACK FOOTER //
// ./src/app/public-views/public-views.component.ts